import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ProtocolFreshCycleForm } from "../../../util/protocolCreation/protocol.formHelper";
import { downloadFreshCycleProtocol } from "../../../util/protocolCreation/freshCycleProtocol";
import PrimaryButton from "../../buttons/PrimaryButton";
import TextInput from "../../fromComponents/TextInput";
import {
  getNameValueObject,
  objectBuilderForPDF,
} from "../../../util/data.util";
import { createReport } from "../../../apis/reports";
import {
  NEED_TO_UPDATE,
  PROTOCOL_FRESH_CYCLE,
} from "../../../constants/Constants";
import { ReportObjCreator } from "../../../util/api.helpers";
import { useDispatch, useSelector } from "react-redux";
import { todaysDate } from "../../../util/getTodaysDate";
import ComponentLoading from "../../loading/ComponentLoading";
import {
  DOWNLOAD_SUCCESS,
  DOWNLOAD_FAILED,
  CREATE_SUCCESS,
  CREATE_FAILED,
} from "../../../constants/SnackbarMessages";
import useSnackbar from "../../../hooks/useSnackbar";
import AddDownload from "../../OptionsComponents/AddDownload";
import TextInputFull from "../../fromComponents/TextInputFull";
import { setProgressNotes } from "../../../redux/slice/progressNotesSlice";

export const FreshCycle = React.memo(() => {
  const patientObject: any = useSelector<PatientState>(
    (state) => state.patient
  );
  const { patient } = patientObject;
  const partnerObject: any = useSelector<PartnerState>(
    (state) => state.partner
  );
  const { partner } = partnerObject;
  const userObject: any = useSelector<UserState>((state) => state.user);
  const { signature } = userObject.user.staff;
  const [reportObj, setReportObj] = useState<FreshCycle>();
  const { register, handleSubmit, reset } = useForm<FreshCycle>();
  const [isDisable, setIsDisable] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { successSnackbar, errorSnackbar } = useSnackbar();
  const progressNotes: any = useSelector<ProgressNotesState>(
    (state) => state.progressNotes
  );
  const dispatch = useDispatch();

  const onSubmit = async (patientData: FreshCycle) => {
    setIsLoading(true);
    patientData.reportDate = todaysDate();
    patientData.signature = signature;
    setReportObj(objectBuilderForPDF(patient, partner, patientData));
  };
  const handleDownload = () => {
    if (reportObj) {
      downloadFreshCycleProtocol(reportObj);
      handleReset();
      successSnackbar(DOWNLOAD_SUCCESS);
    } else {
      errorSnackbar(DOWNLOAD_FAILED);
    }
  };

  const handleReset = () => {
    reset(); // Reset the form fields
    setIsDisable(true);
    setReportObj(undefined);
  };

  const createNewProtocol = async () => {
    if (reportObj) {
      const values = getNameValueObject(reportObj);
      const [response, error] = await createReport(
        ReportObjCreator(
          PROTOCOL_FRESH_CYCLE,
          reportObj.patientId,
          reportObj.patientName,
          reportObj.patientDOB,
          values
        )
      );
      if (response) {
        successSnackbar(`Protocol ${CREATE_SUCCESS}`);
        setIsDisable(false);
        setIsLoading(false);
        dispatch(setProgressNotes([...progressNotes.data, response]));
      } else {
        errorSnackbar(`${CREATE_FAILED} Protocol.${error}`);
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    createNewProtocol();
  }, [reportObj]);

  return isDisable ? (
    <>
      {isLoading ? (
        <ComponentLoading />
      ) : (
        <div className="col-sm-12 ">
          <div className="col-sm-12 p-3">
            <h3 className="text-center">Referral Letter (Fresh cycle)</h3>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="col-sm-12 p-2">
              <div className="row ms-1">
                {ProtocolFreshCycleForm.map((item: InputFieldType) => {
                  return item.id !== "additionalComments" ? (
                    <TextInput
                      keyName={item.id}
                      register={register}
                      placeholder={item.placeholder}
                      id={item.id}
                      label={item.label}
                      type={item.type}
                      listName={item.id + "list"}
                      options={item.options}
                      required={item.required}
                      tag={item.tag}
                      maxLength={item.maxLength}
                      minRows={item.minRows}
                    />
                  ) : (
                    <TextInputFull
                      keyName={item.id}
                      register={register}
                      placeholder={item.placeholder}
                      id={item.id}
                      label={item.label}
                      type={item.type}
                      listName={item.id + "list"}
                      options={item.options}
                      required={item.required}
                      tag={item.tag}
                      maxLength={item.maxLength}
                      minRows={item.minRows}
                    />
                  );
                })}
              </div>
            </div>
            <PrimaryButton label={"Save"} type={"submit"} className={""} />
          </form>
        </div>
      )}
    </>
  ) : (
    <AddDownload onDownload={handleDownload} onReset={handleReset} />
  );
});
